<template>
    <div :class="className" :style="style" @click.prevent.stop="{}"  @mousedown.stop="startDrag">
        <!--<div class="rotate" @mousedown.stop="startRotate">-->
            <!--<div class="angle" v-show="rotating">{{(selected.rotate||0).toFixed(1)}}°</div>-->
            <!--<img src="../../assets/images/rotate.svg" />-->
        <!--</div>-->
        <div class="remove" @click="remove">
            <img src="../../assets/images/delete.svg" />
        </div>
        <!--<div class="cube n" @mousedown.stop="startScale('n',$event)"></div>-->
        <!--<div class="cube ne" @mousedown.stop="startScale('ne',$event)"></div>-->
        <!--<div class="cube e" @mousedown.stop="startScale('e',$event)"></div>-->
        <!--<div class="cube se" @mousedown.stop="startScale('se',$event)"></div>-->
        <!--<div class="cube s" @mousedown.stop="startScale('s',$event)"></div>-->
        <!--<div class="cube sw" @mousedown.stop="startScale('sw',$event)"></div>-->
        <!--<div class="cube w" @mousedown.stop="startScale('w',$event)"></div>-->
        <!--<div class="cube nw" @mousedown.stop="startScale('nw',$event)"></div>-->
        <!--<div class="position" v-show="moving">{{(selected.x||0)}},{{(selected.y||0)}}</div>-->
        <!--<div class="editor" ref="text" contenteditable="plaintext-only" @keydown.enter.prevent="updateTextContent"-->
             <!--@blur="updateTextContent">-->

        <!--</div>-->
    </div>
</template>

<style lang="scss">
    @import "../../stylesheets/base";

    $dir: (n, ne, e, se, s, sw, w, nw, n, ne, e, se, s, sw, w, nw, n, ne, e, se, s, sw, w, nw);
    $map: (0:0, 1:1, 2:2, 3:3, 4:4, 5:5, 6:6, 7:7, 8:8, 9:9);
    @function number($string) {
        @return map-get($map, $string)
    }

    .selection-box {
        position: absolute;
        border: 1px solid $green;
        cursor: move;
        top: 9999px;
        box-sizing: border-box;
        z-index: $baseIndex + 1100;

        .editor {
            width: 100%;
            height: 100%;
            display: none;
            user-modify: read-write-plaintext-only;
            white-space: nowrap;
        }

        &.editing {
            .editor {
                display: block;
                outline: none;
            }
        }

        .position {
            color: #FFFFFF;
            background: rgba(0, 0, 0, .4);
            position: absolute;
            right: -5px;
            bottom: 0;
            transform: translateX(100%);
            font-size: 12px;
            padding: 0 3px;
            border-radius: 2px;
        }

        @for $x from 1 through 8 {
            $type1: nth($dir, $x);
            &.#{$type1} {
                > .cube {
                    @for $i from 1 through 8 {
                        $type2: nth($dir, $i);
                        &.#{$type2} {
                            width: $x + $i;
                            $type3: nth($dir, $x + $i - 1);
                            cursor: #{$type3}-resize;
                        }
                    }
                }
            }
        }
        &.rotating {
            opacity: 0.5;
            .cube {
                display: none;
            }
        }
        &.moving, &.editing {
            .cube, .rotate {
                display: none;
            }
        }
        &.moving {
            opacity: 0.5;
        }

        >.remove,>.rotate{
            >img{
                position: absolute;
                left: 50%;
                top: 50%;
                pointer-events: none;
                @include transform(translate(-50%, -50%));
            }
        }

        >.remove{
            cursor: pointer;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: $green;
            color:#FFF;
            text-align: center;
            line-height:16px;
            position: absolute;
            top: -8px;
            right:-8px;
        }

        > .rotate {
            cursor: pointer;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: $green;
            position: absolute;
            top: -8px;
            left: 50%;
            @include transform(translateX(-50%));
            .angle {
                position: absolute;
                color: #FFFFFF;
                background: rgba(0, 0, 0, .4);
                transform: translate(-50%, -20px);
                left: 50%;
                top: 0;
                font-size: 12px;
                padding: 0 3px;
                border-radius: 2px;
            }
        }
        > .cube {
            width: 10px;
            height: 10px;
            position: absolute;
            background: #fff;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
            cursor: pointer;
            &.n {
                top: -6px;
                left: 50%;
                @include transform(translateX(-50%));
            }
            &.s {
                bottom: -6px;
                left: 50%;
                @include transform(translateX(-50%));
            }
            &.w {
                top: 50%;
                left: -6px;
                @include transform(translateY(-50%));
            }
            &.e {
                top: 50%;
                right: -6px;
                @include transform(translateY(-50%));
            }
            &.ne {
                right: -6px;
                top: -6px;
            }
            &.nw {
                left: -6px;
                top: -6px;
            }
            &.se {
                right: -6px;
                bottom: -6px;
            }
            &.sw {
                left: -6px;
                bottom: -6px;
            }
        }
        > .handle {
            position: absolute;
            right: -20px;
            top: -20px;
            padding-top: 15px;
            padding-right: 15px;
            > .icon-rotate {
                display: block;
                font-size: 20px;
                background-color: #fff;
                color: $green;
                border-radius: 50%;
            }
        }
    }
</style>

<script>
	export default {
		data() {
			return {}
		},
		computed: {
			selected() {
				return this.$store.state.selected
			},
			canvas() {
				return this.$store.state.canvas
			},
			scaleRate() {
				return this.$store.state.scaleRate
			},
			moving() {
				return this.$store.state.moving
			},
			rotating() {
				return this.$store.state.rotating
			},
			editing() {
				return this.$store.state.editing
			},
			style() {
				if (this.selected && this.selected.id) {
					// const mask = this.temp_mask || this.mask
					// const ids = this.mask.id.split("-")
					// const rotate = mask.rotate
					const width = this.selected.width * this.scaleRate
					const height = this.selected.height * this.scaleRate
					return {
						// zIndex: parseInt(ids[ 0 ]) * 100 + parseInt(ids[ 1 ]) * 10 + 1,
						transform: 'rotate(' + this.selected.rotate + 'deg)',
						zIndex: this.selected.zIndex,
						left: this.selected.x * this.scaleRate + "px",
						top: this.selected.y * this.scaleRate + "px",
						width: Math.max(width, 10) + "px",
						height: height === 'auto' ? 'auto' : (Math.max(height, 10) + "px"),
					}
				} else {
					return {
						display: 'none'
					}
				}
			},
			className() {
				const rotate = [ '', 'sw', 'w', 'nw', 'n', 'ne', 'e', 'se', 's' ]
				let className = [ 'selection-box' ]
				if (this.editing) {
					className.push('editing')
				}
				if (this.moving) {
					className.push('moving')
				}
				if (this.rotating) {
					className.push('rotating')
				}
				let rotateClass = rotate[ Math.floor((this.selected.rotate + 22.5 + 180) / 45) ]
				className.push(rotateClass)
				return className.join(' ')
			}
		},
		methods: {
			startDrag(e) {
				this.$store.dispatch('action_start_drag', {
					id: this.selected.id,
					event: e
				})
			},
			startRotate(e) {
				this.$store.dispatch('elm_start_rotate', {
					id: this.selected.id,
					event: e
				})
			},
			startScale(type, e) {
				this.$store.dispatch('elm_start_scale', {
					id: this.selected.id,
					event: e,
					type
				})
			},
			startEditText() {
				if (this.selected.type !== 'text' || this.selected.isDynamic) return false
				this.$store.dispatch('elm_start_edit_text', {
					id: this.selected.id
				})
				this.$nextTick(() => {
					const elm = this.$refs.text;
					const comp = this.canvas.find(item => item.id === this.selected.id)
					elm.innerText = comp.content
					elm.style = comp.style
					const range = document.createRange();
					range.selectNodeContents(elm);
					window.getSelection().removeAllRanges();
					window.getSelection().addRange(range);
				})
			},
			updateTextContent() {
				if (!this.editing) return false
				const elm = this.$refs.text;
				this.$store.dispatch('elm_complete_edit_text', {
					data: {
						content: elm.innerText
					}
				})

			},
			remove(){
                this.$store.commit('action_remove', {
                	id: this.selected.id
                })
				this.$store.dispatch('elm_unselect')
				this.$nextTick(()=> {
					this.$store.dispatch('videoTemplate/updateElements')
				})
            }
		}
	}
</script>
